import { GetOneEnrollmentInDto, GetOneEnrollmentOutDto } from "../../../types/enrollment.dto";

export const GET_ONE_ENROLLMENT = "GET_ONE_ENROLLMENT";
export const GET_ONE_ENROLLMENT_SUCCESS = "GET_ONE_ENROLLMENT_SUCCESS";
export const GET_ONE_ENROLLMENT_ERROR = "GET_ONE_ENROLLMENT_ERROR";
export const RESET_GET_ONE_ENROLLMENT = "RESET_GET_ONE_ENROLLMENT";

export interface GetOneEnrollment {
  type: typeof GET_ONE_ENROLLMENT;
  payload: GetOneEnrollmentOutDto;
}

export interface GetOneEnrollmentSuccess {
  type: typeof GET_ONE_ENROLLMENT_SUCCESS;
  payload: GetOneEnrollmentInDto;
}

export interface GetOneEnrollmentError {
  type: typeof GET_ONE_ENROLLMENT_ERROR;
  payload: string | boolean;
}

export interface ResetGetOneEnrollment {
  type: typeof RESET_GET_ONE_ENROLLMENT;
  payload: null;
}

export interface State {
  data: GetOneEnrollmentInDto | null;
  states: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
};

export type Actions =
  | GetOneEnrollment
  | GetOneEnrollmentSuccess
  | GetOneEnrollmentError
  | ResetGetOneEnrollment;
